/**
 * ContractSlice Rule Reducers
 * 
 * Reducers for managing rule modal state.
 */

import { PayloadAction } from '@reduxjs/toolkit';
import { ContractSliceState } from '../state';

/**
 * Open the rule modal with optional rule ID
 */
export const openRuleModal = (
  state: ContractSliceState,
  action: PayloadAction<string | null>
) => {
  state.ruleModalOpen = true;
  state.selectedRuleId = action.payload;
};

/**
 * Close the rule modal
 */
export const closeRuleModal = (state: ContractSliceState) => {
  state.ruleModalOpen = false;
  state.selectedRuleId = null;
};

/**
 * Set the selected rule ID
 */
export const setSelectedRuleId = (
  state: ContractSliceState,
  action: PayloadAction<string | null>
) => {
  state.selectedRuleId = action.payload;
};

/**
 * Toggle the rule modal (for backward compatibility with toggleRuleModal)
 */
export const toggleRuleModal = (
  state: ContractSliceState,
  action: PayloadAction<string | null>
) => {
  state.ruleModalOpen = !state.ruleModalOpen;
  state.selectedRuleId = action.payload;
  if (!state.ruleModalOpen) {
    state.selectedRuleId = null;
  }
};
